import React from "react";
import { Navbar3 } from "./components/Navbar3";
import { Header62 } from "./components/Header62";
import { Gallery10 } from "./components/Gallery10";
import { Gallery10_1 } from "./components/Gallery10_1";
import { Gallery10_2 } from "./components/Gallery10_2";
import { Gallery10_3 } from "./components/Gallery10_3";
import { Faq13 } from "./components/Faq13";
import { Cta13 } from "./components/Cta13";
import { Contact18 } from "./components/Contact18";

export default function Page() {
  return (
    <div>
      <Navbar3 />
      <Header62 />
      <Gallery10 />
      <Gallery10_1 />
      <Gallery10_2 />
      <Gallery10_3 />
      <Faq13 />
      <Cta13 />
      <Contact18 />
    </div>
  );
}
